function init_calculate_kit_box(form, place_creator) {

    let calculate = new CalculateKitBox();

    calculate.calculate('#calculate_kit_box_form');

    $('#calculate_kit_box_form').on('afterValidate', function () {

        let error = document.getElementsByClassName('has-error');

        if (error.length > 0) {
            $(error[0]).find('input').focus();
        }
    });
}